import {Component, EventEmitter, Injector, OnInit, Output, ViewChild} from '@angular/core';
import {AppComponentBase} from '@shared/common/app-component-base';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {BaseModalButton, BaseModalOption} from './models';
import {ActivatedRoute, Router} from '@angular/router';


@Component({
    selector: 'app-base-modal',
    templateUrl: './base-modal.component.html',
    styleUrls: ['./base-modal.component.less']
})
export class BaseModalComponent extends AppComponentBase implements OnInit {

    @ViewChild('myappBaseModal', {static: true}) mymodal: ModalDirective;
    @Output() onYesClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onNoClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    customOptions = false;
    text = '';
    option1 = '';
    option2 = '';
    oneOptionMode = false;
    isLoading = false;

    buttons: BaseModalButton[] = [];

    options: BaseModalOption = undefined;

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.registerLoadingEvents();
    }

    registerLoadingEvents() {
        abp.event.on('app.show.loadingBarShow', () => {
            this.close();
        });
        abp.event.on('app.show.loadingBarHide', () => {
            this.close();
        });
    }

    show(info: string, options: string[] = [], oneOptionMode: boolean = false): void {
        this.active = true;
        this.text = info;

        if (options.length !== 0) {
            this.option1 = options[0];
            this.option2 = options[1];
            this.customOptions = true;
        }
        this.oneOptionMode = oneOptionMode;

        this.mymodal.show();
    }

    close(): void {
        this.active = false;
        this.customOptions = false;
        this.options = undefined;

        this.buttons = [];

        if (this.isGuided) {
            this.onClose.emit();
        }

        this.mymodal.hide();
    }

    onYes(): void {
        this.active = false;
        this.mymodal.hide();
        this.onYesClick.emit();
    }

    onNo(): void {
        this.active = false;
        this.mymodal.hide();
        this.onNoClick.emit();
    }

    //#region Proper way

    showUpdated(options: BaseModalOption) {
        this.active = true;
        this.customOptions = true;
        this.text = options.text;

        this.options = options;

        if (options.buttons && options.buttons.length > 0) {
            this.buttons = options.buttons;
        }

        this.mymodal.show();
    }

    redirectTo(url: string) {
        this.close();

        this._router.navigate([url]);
    }

    //#endregion Proper way
}
